import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { MerakiSwitchStatus } from '@app/shared/models/meraki/meraki-switch-status.model';


@Component({
    selector: 'app-meraki-card',
    templateUrl: './meraki-card.component.html',
    styleUrls: ['./meraki-card.component.css'],
    standalone: false
})
export class MerakiCardComponent implements OnInit, OnDestroy {
    @Input() meraki_switch_status: MerakiSwitchStatus;

    constructor() {}

    ngOnInit() {}
    ngOnDestroy() {}


}